import { Text, useMantineTheme } from "@mantine/core";
import { Modal } from "../../../../components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IProps {
  clorderid: string | number;
  help_reject_url: string;
  reject_desc: string;
  handleCloseModalError: () => void;
}

export default function ModalReject({
  clorderid,
  help_reject_url,
  reject_desc,
  handleCloseModalError,
}: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Modal
      type={"warning"}
      textModal={t("operacoes.modal_error_reject.text_modal", {
        clorderid: clorderid || "",
      })}
      titleSeccondButton={t("global.modal.close")}
      contentEspecial={
        !!help_reject_url ? (
          <Text
            c="basic.4"
            fz="14px"
            lh="155%"
            ta={"center"}
            w="320px"
            mb="32px"
          >
            {t("operacoes.modal_error_reject.content_especial")}
            <Link
              to={help_reject_url}
              target="_blank"
              style={{ color: theme.colors.basic[5], fontWeight: 700 }}
            >
              {t("operacoes.modal_error_reject.click")}
            </Link>
          </Text>
        ) : null
      }
      description={`${reject_desc || ""}`}
      open={!!clorderid}
      setClose={handleCloseModalError}
      secondClick={handleCloseModalError}
    />
  );
}
